import React, { useContext, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';

const ProtectedRoute = ({ children }) => {
  const { user } = useContext(UserContext);

  useEffect(() => {
    console.log("ProtectedRoute rendered with user state:", user);
  }, [user]);

  if (user.loading) {
    console.log("ProtectedRoute: User data is loading");
    return <div>Loading...</div>;
  }

  if (!user.loggedIn) {
    console.log("ProtectedRoute: User is not logged in, redirecting to login");
    return <Navigate to="/auth/login" replace />;
  }

  console.log("ProtectedRoute: User is authenticated, rendering children");
  return children;
};

export default ProtectedRoute;